import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Bot, FileText, BarChart3, Settings, Menu, X, Zap } from 'lucide-react';
import './AdminLayout.css';

const NAV = [
  { path: '/admin', label: 'لوحة التحكم', icon: LayoutDashboard, exact: true },
  { path: '/admin/agents/new', label: 'وكيل جديد', icon: Bot },
  { path: '/admin/results', label: 'النتائج', icon: FileText },
  { path: '/admin/insights', label: 'الرؤى', icon: BarChart3 },
];

export default function AdminLayout({ children, title, subtitle, actions }) {
  const loc = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path, exact) =>
    exact ? loc.pathname === path : loc.pathname.startsWith(path);

  return (
    <div className="admin-wrap">
      {/* Sidebar */}
      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <div className="brand-icon">🍔</div>
            <div>
              <div className="brand-name">UX Insights</div>
              <div className="brand-sub">منصة أبحاث المستخدم</div>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {NAV.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              <item.icon size={17} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <Link to="/admin" className="nav-item" style={{ fontSize: '12px', opacity: 0.7 }}>
            <Settings size={15} />
            <span>الإعدادات</span>
          </Link>
          <div className="api-badge">
            <Zap size={12} />
            <span>Gemini 2.0 Flash</span>
          </div>
        </div>
      </aside>

      {/* Mobile overlay */}
      {mobileOpen && <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />}

      {/* Main */}
      <div className="admin-main">
        <header className="admin-header">
          <button className="mobile-menu-btn" onClick={() => setMobileOpen(v => !v)}>
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          <div className="header-text">
            {title && <h1 className="header-title">{title}</h1>}
            {subtitle && <p className="header-sub">{subtitle}</p>}
          </div>
          {actions && <div className="header-actions">{actions}</div>}
        </header>

        <main className="admin-content">
          {children}
        </main>
      </div>
    </div>
  );
}
